import styled, { css } from "styled-components";
import { buttonAppearance } from "styles/mixins";

export interface ButtonProps {
  inverted?: boolean;
  fullWidth?: boolean;
}

export const Button = styled.button<ButtonProps>`
  ${buttonAppearance()}

  ${(props) =>
    props?.fullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props?.inverted
      ? css`
          border-color: #000;
          background: #fff;
          color: #000;
          font: 14px/22px "Museo Sans", sans-serif;
        `
      : css`
          background: #000;
          color: #fff;
          border-color: #000;
          font: 14px/22px "Museo Sans", sans-serif;
        `}
`;
